'use client';

import { useTranslations } from 'next-intl';
import { badgeSizes, memberTierBadge, memberTierDefaultBadge } from '../../lib/badgeColors';

type TierBadgeProps = {
  tier: 'FREE' | 'PRO';
  subscriptionStatus?: string | null;
  loading?: boolean;
};

export const TierBadge = ({ tier, subscriptionStatus, loading = false }: TierBadgeProps) => {
  const t = useTranslations('billing.tier');

  const isTrial = subscriptionStatus === 'TRIALING';

  if (isTrial) {
    return <span className={`${badgeSizes.xs} bg-warning/20 text-warning`}>{t('trial')}</span>;
  }

  if (tier === 'PRO') {
    // Trial vs Pro can only be told apart once the subscription status loads.
    // Until then, hold a neutral placeholder instead of falsely showing "Pro".
    if (loading) {
      return (
        <span className={`${badgeSizes.xs} ${memberTierDefaultBadge} animate-pulse`} aria-hidden="true">
          &middot;&middot;&middot;
        </span>
      );
    }

    return <span className={`${badgeSizes.xs} ${memberTierBadge.PRO}`}>{t('pro')}</span>;
  }

  return <span className={`${badgeSizes.xs} ${memberTierDefaultBadge}`}>{t('free')}</span>;
};
